import { useMemo } from 'react';
import { getBillClientServiceOptions } from '~/business-logic/billServiceSelector';
export const useAgreementServiceOptions = (param)=>{
    let { services, controlData, items } = param;
    return useMemo(()=>getBillClientServiceOptions({
            items,
            services,
            controlData
        }), [
        items,
        services,
        controlData
    ]);
};
